// extracted by css-extract-rspack-plugin
export default {"menu":"menu-sbtIus","header":"header-ftXT30","listScrollable":"listScrollable-THwBoX","menuButton":"menuButton-vEfCaA","loaderContainer":"loaderContainer-OfELBO"};